import {
  Button,
  Label,
  Table,
  TableBody,
  TableCell,
  TableCellActions,
  TableCellLayout,
  TableHeader,
  TableHeaderCell,
  TableRow,
  makeStyles,
  shorthands,
  Dropdown,
  Option,
  useId,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogTrigger,
  Spinner,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from "@fluentui/react-components";
import {
  EditFilled,
  EditRegular,
  WalletCreditCardFilled,
  WalletCreditCardRegular,
  bundleIcon,
  AccessTimeFilled,
  AccessTimeRegular,
  FilterRegular,
  FilterFilled,
  DocumentRegular,
  DocumentFilled
} from "@fluentui/react-icons";
import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import UserForm, { InitialUserState } from "./components/Forms/UserForm";
import UserWalletForm from "./components/Forms/UserWalletForm";
import Layout from "./components/Layout";
import { notify } from "./components/AppNotifications";
import { Base_Url, auth, db, trackException } from "./services/firebase";
import UserDataService from "./services/userDataService";
import CustomSearchInput from "./components/CustomSearchInput";
import ExportCsvButtons from "./components/ExportCsvButtons";
import { asText } from "./components/CsvExportUtil";
import debounce from 'lodash/debounce';
import { CheckBoxChecked, CheckBoxUnChecked, DownArowSVG, DownSmallArrow, FilterSVG, PlusSVG } from "./static/svgs";
import './Users.css';
import useBreakpoint from "./hooks/useBreakpoint";
import './components/Forms/FormStyle.css';

const EditIcon = bundleIcon(EditFilled, EditRegular);
const WalletIcon = bundleIcon(WalletCreditCardFilled, WalletCreditCardRegular);
const FilterIcon = bundleIcon(FilterFilled, FilterRegular);
const DocumenIcon = bundleIcon(DocumentFilled, DocumentRegular);

const useStyles = makeStyles({
  root: {
    ...shorthands.overflow("hidden"),
    display: "flex",
    height: "480px",
    backgroundColor: "#fff",
  },

  content: {
    ...shorthands.flex(1),
    ...shorthands.padding("16px"),
    display: "block",
    ...shorthands.gridArea("main"),
  },

  breakFlex: {
    flexBasis: "100%",
    textAlign: "left",
  },

  breakFlexData: {
    flexBasis: "100%",
    ...shorthands.padding("8px"),
    textAlign: "left",
  },
});

const columns = [
  { columnKey: "memberNumber", label: "Member Id", width: '10%' },
  { columnKey: "membershipStatus", label: "Status", width: '10%' },
  { columnKey: "firstName", label: "First Name", width: '16%' },
  { columnKey: "lastName", label: "Last Name", width: '16%' },
  { columnKey: "genderValue", label: "Gender", width: '10%' },
  { columnKey: "email", label: "Email", width: '12%' },
  { columnKey: "isAdmin", label: "Admin", width: '10%' },
  { columnKey: "isHonorary", label: "Honorary Member", width: '10%' },
  { columnKey: "address", label: "Address", width: '14%' },
];

function Users() {
  const options = [
    { key: "Male", text: "Male" },
    { key: "Female", text: "Female" },
    { key: "prefer_not_to_say", text: "Prefer not to say" },
    { key: "All", text: "All" },
  ];
  const styles = useStyles();
  const [user, loading, error] = useAuthState(auth);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isWalletFormOpen, setWalletIsFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [allusers, setAllUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUser, setFilteredUser] = useState([]);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [popupVisible, setPopupVisible] = useState(false);
  const breakFlexpoint = useBreakpoint();
  const isMobile = breakFlexpoint === 'mobile';

  const [open, setOpen] = React.useState(false);
  // Archiving replaces deleting a member. Kept separate from the shared delete
  // dialog because the wording and the consequences are different.
  const [archiveTarget, setArchiveTarget] = React.useState(null);
  const [archiving, setArchiving] = React.useState(false);
  // Which row is mid status-change, so its control disables rather than the whole grid.
  const [statusBusyId, setStatusBusyId] = React.useState(null);
  const navigate = useNavigate();
  const openForm = (selectedItem) => {
    setIsFormOpen(true);
    setSelectedUser(selectedItem);
  };
  const [selectedGenderOption, setSelectedGenderOption] = useState();
  const [tempGenderOption, setTempGenderOption] = useState(); // Temporary while popup is open
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });


  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserNameAndUsers();
  }, [selectedGenderOption]);

  const openFormNew = () => {
    setIsFormOpen(true);
    let r = (Math.random() + 1).toString(36).substring(7);
    setSelectedUser(r);
  };

  const openWalletForm = (selectedItem) => {
    setWalletIsFormOpen(true);
    setSelectedUser(selectedItem);
  };

  const fetchUserNameAndUsers = async () => {
    try {
      if (!!user) {
        const userquery = query(
          collection(db, "Users"),
          where("email", "==", user?.email)
        );
        const userdoc = await getDocs(userquery);
        if (userdoc.docs.length > 0) {
          if (selectedGenderOption != undefined && selectedGenderOption != "All") {
            const usersQuery = await UserDataService.getUserByGender(selectedGenderOption);
            let userArr = usersQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            userArr.sort((a, b) => {
              const lastNameA = a.lastName || ''; // If lastName is null or undefined, treat it as empty string
              const lastNameB = b.lastName || ''; // If lastName is null or undefined, treat it as empty string
              return lastNameA.localeCompare(lastNameB); // Compare the last names alphabetically
            });
            setFilteredUser(userArr)
            setAllUsers(userArr);
          } else {
            const usersQuery = await UserDataService.getAllUser();
            let userArr = usersQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            userArr.sort((a, b) => {
              const lastNameA = a.lastName || ''; // If lastName is null or undefined, treat it as empty string
              const lastNameB = b.lastName || ''; // If lastName is null or undefined, treat it as empty string
              return lastNameA.localeCompare(lastNameB); // Compare the last names alphabetically
            });

            setFilteredUser(userArr)
            setAllUsers(userArr);
          }
        } else {
          console.log("no access");
        }
      }
    } catch (err) {
      trackException(JSON.stringify(err))
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  const handleFirstNameClick = (item) => {
    navigate(`/userdetails`, { state: item });
    //navigate(`/MemberPurchaseDetails`, { state: item });
  };
  const handleMemberPurchaseClick = (item) => {
    navigate(`/MemberPurchaseDetails`, { state: item });
  };

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserNameAndUsers();
  }, [user, loading]);

  // Membership lifecycle. Members created before this field existed have no value,
  // and they are active — so absent reads as active rather than as unknown.
  const STATUS_LABEL = { active: "Active", paused: "Paused", archived: "Archived" };
  const statusOf = (member) => (member && member.membershipStatus) || "active";

  // Paused is a label only, as specified: it does not touch Stripe and the member
  // keeps their member number, because they are still the holder of it.
  async function changeStatus(member, status) {
    setStatusBusyId(member.id);
    try {
      const token = await auth.currentUser?.getIdToken();
      await axios.post(
        `${Base_Url}/api/setMembershipStatus`,
        { userId: member.id, status, reason: `set to ${status} from the member list` },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUserNameAndUsers();
    } catch (error) {
      const res = error.response;
      const msg =
        (res && res.data && res.data.error && res.data.error.message) ||
        error.message || "Could not change status";
      // A 409 means the member number is still held by another member. The server
      // names who and says what to do about it, so show that message as-is rather
      // than burying it under a generic failure.
      notify(res && res.status === 409 ? msg : `Could not change status: ${msg}`, "error");
      trackException(JSON.stringify(error));
    } finally {
      setStatusBusyId(null);
    }
  }

  // One control that both shows the current status and changes it. Staff could not
  // see a member's status at all before this - the list showed archived members
  // identically to active ones - and Archive was the only status they could set.
  const renderStatusMenu = (item) => {
    const current = statusOf(item);
    return (
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button
            appearance="subtle"
            size="small"
            disabled={statusBusyId === item.id}
            aria-label={`Membership status: ${STATUS_LABEL[current]}`}
            style={current === "archived" ? { color: "#8a8886" } : undefined}
          >
            {statusBusyId === item.id ? <Spinner size="tiny" /> : STATUS_LABEL[current]}
          </Button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem disabled={current === "active"} onClick={() => changeStatus(item, "active")}>
              Active
            </MenuItem>
            <MenuItem disabled={current === "paused"} onClick={() => changeStatus(item, "paused")}>
              Paused — member asked to pause
            </MenuItem>
            {/* Archive keeps its confirmation: it releases the member number for
                reissue, which the other two do not. */}
            <MenuItem disabled={current === "archived"} onClick={() => setArchiveTarget(item)}>
              Archive…
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    );
  };

  // Members are archived, not deleted.
  //
  // Deleting was what caused the Holly Brown #091 bug: the record went, the member
  // number came back round to someone new, and the previous member's data surfaced
  // on the new one. Archiving keeps the record and its history, sets the lifecycle
  // status, and closes the member-number tenure so the number can be reissued
  // safely — the server records WHEN it was released, which is what stops the next
  // holder inheriting the old spend.
  //
  // The old delete path (UserDataService.deleteUser + /deleteUserAuth) is
  // deliberately gone from this screen rather than left alongside as a shortcut.
  const ArchiveUser = async () => {
    if (!archiveTarget) return;
    setArchiving(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      await axios.post(
        `${Base_Url}/api/setMembershipStatus`,
        { userId: archiveTarget.id, status: "archived", reason: "archived from the member list" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setArchiveTarget(null);
      fetchUserNameAndUsers();
    } catch (error) {
      const msg =
        (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
        error.message || "Could not archive this member";
      notify(msg, "error");
      trackException(JSON.stringify(error));
    } finally {
      setArchiving(false);
    }
  };


  const getValueByKey = (item, key) => {
    // Members predating the field have no value and are active, so sort them as
    // active rather than as blank.
    if (key === "membershipStatus") return statusOf(item);
    if (key === "address") return item?.address?.city || '';  // Handle address field
    if (key === "memberNumber") {
      // Convert memberNumber to a number for sorting, handle invalid member numbers
      const memberNumber = item[key];
      if (!memberNumber || isNaN(memberNumber) || memberNumber === "-") {
        return -Infinity; // If invalid or "-" treat as very low for sorting purposes
      }
      return parseInt(memberNumber, 10); // Otherwise return the numeric value
    }
    return item?.[key] ?? '';  // Return empty string if value is missing for other fields
  };

  // Export All has to go back to the database rather than read `allusers`.
  // When a Gender filter is active the screen re-queries with getUserByGender
  // and puts that result into `allusers` as well as `filteredUser`, so the
  // state named "all" is only all-of-the-chosen-gender. Reading it here made
  // Export All quietly produce the same rows as Export Filtered.
  const fetchAllMembersForExport = async () => {
    const snapshot = await UserDataService.getAllUser();
    return snapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }))
      .sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""));
  };

  // One exported row, matching the columns shown in the table so the file and
  // the screen agree. Member Id goes through asText because Excel turns 00013
  // into 13, and the portal and members both refer to the padded form.
  const toExportRow = (item) => ({
    "Member Id": asText(item?.memberNumber ?? ""),
    // STATUS_LABEL, not the raw value: the column on screen reads Active,
    // and an export that says "active" stops matching what staff just looked at.
    "Status": STATUS_LABEL[statusOf(item)] ?? statusOf(item),
    "First Name": item?.firstName ?? "",
    "Last Name": item?.lastName ?? "",
    "Gender": item?.genderValue ?? "",
    "Email": item?.email ?? "",
    "Admin": item?.isAdmin ? "Yes" : "No",
    "Honorary Member": item?.isHonorary ? "Yes" : "No",
    "Address": item?.address?.city ?? "",
  });

  // Sorting handler
  const handleSort = (columnKey) => {
    setSortConfig((prev) => {
      if (prev.key === columnKey) {
        return { key: columnKey, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key: columnKey, direction: 'asc' };
    });
  };

  // Sort the filteredUser array based on sortConfig
  const sortedUsers = React.useMemo(() => {
    if (!sortConfig.key) return filteredUser;

    return [...filteredUser].sort((a, b) => {
      const aValue = getValueByKey(a, sortConfig.key);
      const bValue = getValueByKey(b, sortConfig.key);

      // Numeric sort if both values are numbers (including Member Id)
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === 'asc'
          ? aValue - bValue
          : bValue - aValue;
      }

      // String sort if values are not numbers (for example, firstName, lastName, etc.)
      const aStr = String(aValue).toLowerCase();
      const bStr = String(bValue).toLowerCase();

      if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredUser, sortConfig]);


  // Debounce the handleSearch function
  const debouncedSearch = debounce(search => {
    const lowerSearch = search.toLowerCase();
    const filtered = allusers.filter(event => {
      return (
        event.firstName.toLowerCase().includes(lowerSearch) ||
        event.lastName.toLowerCase().includes(lowerSearch) ||
        String(event.memberNumber).toLowerCase().includes(lowerSearch)
      )
    }
    );
    setFilteredUser(filtered);
  }, 300); // Adjust the debounce delay as needed

  const handleSearch = event => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };
  const handleClear = () => {
    setSearchTerm('');
    debouncedSearch('');
  };

  const openPopup = (event) => {
    // Calculate the position of the button
    const buttonRect = event.target.getBoundingClientRect();
    const buttonX = buttonRect.left + (buttonRect.width / 2);
    const buttonY = buttonRect.top + (buttonRect.height / 2);
    setPopupPosition({ x: buttonX, y: buttonY + 10 }); // Adjust 10px downward for better alignment
    // Show the popup
    setPopupVisible(true);
  };

  const toggleSelect = (id) => {
    setTempGenderOption(id);
  };

  const handleApplyFilter = () => {
    setSelectedGenderOption(tempGenderOption); // Save selection
    setPopupVisible(false);
  };

  const handleCancelFilter = () => {
    setSelectedGenderOption(null);
    setTempGenderOption(null); // Revert to previous
    setPopupVisible(false);
  };

  return (
    <Layout>
      <div className={styles.content}>
        <div className={"d-flex justify-space-between top-content"}>
          <div className={"d-flex"} style={{ gap: 8 }}>
            <Button
              icon={<PlusSVG />}
              shape="circular"
              appearance="primary"
              onClick={() => openFormNew()}
              className={"primary-btn"}
            >{'New Users'.toUpperCase()}
            </Button>
            {/* Filtered exports what the search and Gender filter leave on
                screen; All re-reads every member, because a Gender filter
                replaces the loaded set rather than narrowing it. */}
            <ExportCsvButtons
              screenName="Members"
              getFilteredRows={() => sortedUsers}
              getAllRows={fetchAllMembersForExport}
              mapRow={toExportRow}
            />
          </div>
          <CustomSearchInput
            className={"custom-search-input"}
            value={searchTerm}
            onChange={handleSearch}
            onClick={handleClear}
          />
        </div>

        <div className={styles.breakFlexData}>
          <div className={"d-flex justify-space-between"}>
            <div className={"d-flex"}>
              <div style={{ marginTop: '8px' }}>
                <FilterSVG />
              </div>
              {/* <div className={'memberNameDiv'} onClick={() => { }}>
                <span>Invoice status</span>
                <DownArowSVG />
              </div> */}
              <div className={'memberNameDiv'} onClick={openPopup}>
                <span>Gender</span>
                <DownArowSVG />
              </div>
            </div>
            <div className={"d-flex"}>
            </div>
          </div>
        </div>

        <div className={"table-layout"} style={{ border: isMobile ? 'none' : undefined }}>
          <Table aria-label="Table with cell actions">
            <TableHeader className={"list-row"}>
              <TableRow>
                {columns.map((column) => (
                  // <TableHeaderCell style={{ width: column.width }} key={column.columnKey}>
                  //   <span className={"listHeaderText"}>{column.label}</span>
                  // </TableHeaderCell>
                  <TableHeaderCell
                    key={column.columnKey}
                    style={{ width: column.width, cursor: "pointer" }}
                    onClick={() => handleSort(column.columnKey)}
                  >
                    <span className={"listHeaderText"}>
                      {column.label}
                      {sortConfig.key === column.columnKey ? (
                        sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽'
                      ) : null}
                    </span>
                  </TableHeaderCell>
                ))}
              </TableRow>
            </TableHeader>
            {sortedUsers.length > 0 && (
  <TableBody>
    {sortedUsers.map((item) =>
      isMobile ? (
        <div key={item.id} className="user-card">
          <div className="user-card-header">
            <div className="user-card-title" onClick={() => handleFirstNameClick(item)}>
              {item.firstName} {item.lastName}
            </div>
            <div className="user-card-actions">
              <Button
                icon={<DocumenIcon />}
                className="doc-icon"
                appearance="subtle"
                aria-label="Document"
                onClick={() => { handleMemberPurchaseClick(item) }}
              />
              <Button
                icon={<WalletIcon />}
                className="wallet-icon"
                appearance="subtle"
                aria-label="Wallet"
                onClick={() => openWalletForm(item)}
              />
              <Button
                icon={<EditIcon />}
                className="edit-icon"
                appearance="subtle"
                aria-label="Edit"
                onClick={() => openForm(item)}
              />
              {renderStatusMenu(item)}
            </div>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">Member #</span>
            <span className="user-card-value">{item.memberNumber || ''}</span>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">Gender</span>
            <span className="user-card-value">{item.genderValue}</span>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">Email</span>
            <span className="user-card-value">{item.email}</span>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">Admin</span>
            <span className="user-card-value">{item.isAdmin ? <div className="yesBox">Yes</div> : <div className="noBox">No</div>}</span>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">Honorary</span>
            <span className="user-card-value">{item.isHonorary ? <div className="yesBox">Yes</div> : <div className="noBox">No</div>}</span>
          </div>
          <span className="separator"></span>
          <div className="user-card-row">
            <span className="user-card-label">City</span>
            <span className="user-card-value">{item?.address?.city}</span>
          </div>
        </div>
      ) : (
        <TableRow key={item.id}>
          <TableCell className={"table-row-fonts__primary"}>
            <TableCellLayout>{item.memberNumber ? item.memberNumber : ''}</TableCellLayout>
          </TableCell>
          <TableCell>
            <TableCellLayout>{renderStatusMenu(item)}</TableCellLayout>
          </TableCell>
          <TableCell className={"table-row-fonts__primary"} onClick={() => handleFirstNameClick(item)}>
            <TableCellLayout>{item.firstName}</TableCellLayout>
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            <TableCellLayout>
              <Label title={item.lastName}>{item.lastName}</Label>
            </TableCellLayout>
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            <TableCellLayout>
              <Label title={item?.genderValue}>{item?.genderValue}</Label>
            </TableCellLayout>
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            <TableCellLayout>
              <Label title={item.email}>{item.email}</Label>
            </TableCellLayout>
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            {item.isAdmin ? <div className={"yesBox"}>Yes</div> : <div className={"noBox"}>No</div>}
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            {item.isHonorary ? <div className={"yesBox"}>Yes</div> : <div className={"noBox"}>No</div>}
          </TableCell>
          <TableCell className={"table-row-fonts__desc"}>
            <TableCellLayout>
              <Label title={item?.address?.city}>{item?.address?.city}</Label>
            </TableCellLayout>
            <TableCellActions>
              <Button
                icon={<DocumenIcon />}
                appearance="subtle"
                aria-label="Document"
                onClick={() => { handleMemberPurchaseClick(item) }}
              />
              <Button
                icon={<WalletIcon />}
                appearance="subtle"
                aria-label="Wallet"
                onClick={() => openWalletForm(item)}
              />
              <Button
                icon={<EditIcon />}
                appearance="subtle"
                aria-label="Edit"
                onClick={() => openForm(item)}
              />
            </TableCellActions>
          </TableCell>
        </TableRow>
      )
    )}
  </TableBody>
)}
          </Table>
        </div>
        {popupVisible && (
          <div className="popupGender" style={{ position: 'absolute', top: popupPosition.y + 10, left: popupPosition.x - 20 }}>
            <div className="popupGenderList">
              {options.map((option) => (
                <div key={option.key}>
                  <Label style={{ marginBottom: '4px' }} className="checkLabeldiv">
                    <div
                      onClick={() => toggleSelect(option.key)}
                      style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                    >
                      {tempGenderOption === option.key ? (
                        <CheckBoxChecked />  // Your checked SVG
                      ) : (
                        <CheckBoxUnChecked />  // Your unchecked SVG
                      )}
                      <div style={{ marginLeft: '8px' }}>{option.text}</div>
                    </div>
                  </Label>
                </div>
              ))}
            </div>
            <div className="filterseperater"></div>
            <div className="buttonContainer">
              <button className="borderButton" onClick={handleCancelFilter}>Cancel</button>
              <button className="fillButton" onClick={() => { handleApplyFilter() }}>APPLY</button>
            </div>
          </div>
        )}
      </div>
      <UserForm
        key={"userform"}
        isOpen={isFormOpen}
        setIsOpen={(val) => setIsFormOpen(val)}
        selectedUser={selectedUser}
        updateGrid={fetchUserNameAndUsers}
        allusers={allusers}
      ></UserForm>
      <UserWalletForm
        key={"UserWalletForm"}
        isOpen={isWalletFormOpen}
        setIsOpen={(val) => setWalletIsFormOpen(val)}
        selectedUser={selectedUser}
        updateGrid={fetchUserNameAndUsers}
      ></UserWalletForm>
      {/* Archiving is not deleting, and the dialog says so rather than reusing the
          generic delete wording. Staff need to know the record survives and that
          the member number becomes reusable — those are the two things that change. */}
      <Dialog open={!!archiveTarget} onOpenChange={(e, d) => { if (!d.open) setArchiveTarget(null); }}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Archive this member?</DialogTitle>
            <DialogContent>
              <p>
                <strong>{`${archiveTarget?.firstName || ""} ${archiveTarget?.lastName || ""}`.trim() || "This member"}</strong>
                {archiveTarget?.memberNumber ? <> — member number <strong>{archiveTarget.memberNumber}</strong></> : null}
              </p>
              <p>
                Their record, payment history and past orders are kept. They are marked
                archived rather than removed.
              </p>
              {archiveTarget?.memberNumber ? (
                <p>
                  Member number <strong>{archiveTarget.memberNumber}</strong> becomes free to
                  give to a new member. Their spend up to today stays with them — the number
                  is released with today's date, so a future holder will not inherit it.
                </p>
              ) : null}
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary" disabled={archiving}>Cancel</Button>
              </DialogTrigger>
              <Button
                appearance="primary"
                onClick={ArchiveUser}
                disabled={archiving}
                icon={archiving ? <Spinner size="tiny" /> : undefined}
              >
                {archiving ? "Archiving…" : "Archive member"}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </Layout>
  );
}

export default Users;
